import {Toast} from "bootstrap";
import Cookies from 'js-cookie';

const COOKIE_NAME = 'vp-favorite-properties';
const COOKIE_EXPIRE_DAYS = 90;
const MAX_FAVORITE_PROPERTIES = 50;

export function initFavoriteProperties() {
    const favoritePropertiesCountElement = document.querySelectorAll('.favorite-properties-count');
    document.querySelectorAll<HTMLElement>('[data-toggle="toast"][data-template][data-property-id][data-property-name]').forEach(element => {
        const template = element.dataset.template;
        if (!template)
            return;
        const templateNode = document.querySelector(template);
        if (!templateNode)
            return;

        element.addEventListener('click', () => {
            const newFavoritePropertiesCount = toggleFavorite(parseInt(element.dataset.propertyId));
            favoritePropertiesCountElement.forEach(el => el.innerHTML = `${newFavoritePropertiesCount}`);
            const isAdded = element.querySelector('.material-symbols-outlined').classList.toggle('filled');
            const toastElement = templateNode.cloneNode(true) as Element;
            toastElement.classList.remove('d-none');
            delete toastElement.id;
            const toastHeaderContent = toastElement.querySelector('.toast-header-text');
            if (toastHeaderContent)
                toastHeaderContent.innerHTML = `${element.dataset.propertyName} ${isAdded ? 'dodano do' : 'usunięto z'}&nbsp;ulubionych`;
            templateNode.parentElement.appendChild(toastElement);
            const toast = new Toast(toastElement);
            toast.show();
            toastElement.addEventListener('hidden.bs.toast', () => toastElement.remove());
        });
    });
}

function toggleFavorite(id: number) {
    const favorites: number[] = JSON.parse(Cookies.get(COOKIE_NAME) || '[]');
    const index = favorites.indexOf(id);
    if (index === -1) {
        favorites.push(id);
    } else {
        favorites.splice(index, 1);
    }
    Cookies.set(COOKIE_NAME, JSON.stringify(favorites.slice(-MAX_FAVORITE_PROPERTIES)), {
        expires: COOKIE_EXPIRE_DAYS,
        sameSite: 'none',
        path: '/',
        secure: true
    });
    return favorites.length;
}